import { Component, Input, OnDestroy, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

const SWITCH_INPUT_CONTROL_VALUE_ACCESSOR = {
  multi: true,
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TmwSwitchInputComponent),
};

const noop = (): void => {};

@Component({
  selector: 'tmw-switch',
  standalone: true,
  templateUrl: './switch-input.component.html',
  imports: [FormsModule],
  providers: [SWITCH_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class TmwSwitchInputComponent implements ControlValueAccessor, OnDestroy {
  _value?: any;
  _disabled: boolean = false;

  @Input() readOnly: boolean = false;

  private onTouched: () => void = noop;
  private onChange: (_: any) => void = noop;

  get field() {
    return this._value;
  }
  set field(val) {
    if (this._value !== val) {
      this._value = !!val;
      this.onChange(this._value);
      this.onTouched();
    }
  }

  constructor() {}

  writeValue(val: any): void {
    this._value = val;
    if(!!val != this._value) {
      this.field = !!val
    }

  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  ngOnDestroy(): void {}
}
